import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { StaffManagerListItem } from "../../staff.types";
import { requestCreateStaffManager } from "./createStaffManager.request";

export const useCreateStaffManager = (
  options?: MutationOptions<StaffManagerListItem, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateStaffManager,
    ...options
  });
};
